import { HowToUseHeroBackdrop } from "../BrandBackdrop";
import { Skeleton } from "../ui/skeleton";

export const HowToUseSkeleton = () => {
  return (
    <div
      className="min-h-screen bg-background"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading how to invest"
    >
      <main className="pb-12">
        {/* Hero — full bleed, matches live page */}
        <div className="vestn-nav-opening mb-16" style={{ minHeight: '28rem' }}>
          <HowToUseHeroBackdrop />
          <div className="container mx-auto px-4 lg:px-8 relative z-10 text-center flex flex-col items-center">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-semibold uppercase tracking-[0.14em] mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-primary" />
              Five Simple Steps
            </div>
            <h1 className="font-display text-4xl lg:text-6xl font-bold text-foreground mb-6 leading-[1.05] tracking-[-0.02em]">
              How to <span className="text-primary">Invest</span>
            </h1>
            <Skeleton className="h-5 w-full max-w-2xl mx-auto mb-2" />
            <Skeleton className="h-5 w-2/3 max-w-md mx-auto mb-8" />
            <div className="flex flex-wrap justify-center gap-6">
              <Skeleton className="h-4 w-36" />
              <Skeleton className="h-4 w-40" />
              <Skeleton className="h-4 w-32" />
            </div>
          </div>
        </div>

        <div className="container mx-auto px-4 lg:px-8">
          {/* Steps */}
          <div className="max-w-4xl mx-auto space-y-8 mb-20">
            {Array.from({ length: 5 }).map((_, index) => (
              <div
                key={index}
                className="flex flex-col md:flex-row gap-6 p-6 rounded-2xl bg-card border border-white/[0.07]"
              >
                <Skeleton className="w-16 h-16 rounded-2xl flex-shrink-0" />
                <div className="flex-1 space-y-3">
                  <Skeleton className="h-5 w-40" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-5/6" />
                  <div className="space-y-2 pt-1">
                    <Skeleton className="h-3 w-48" />
                    <Skeleton className="h-3 w-40" />
                    <Skeleton className="h-3 w-44" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* FAQ */}
          <div className="max-w-3xl mx-auto mb-20">
            <h2 className="font-display text-3xl font-bold text-foreground text-center mb-12">
              Frequently Asked Questions
            </h2>
            <div className="space-y-4">
              {Array.from({ length: 5 }).map((_, index) => (
                <div
                  key={index}
                  className="p-6 rounded-xl bg-card border border-white/[0.07] space-y-2"
                >
                  <Skeleton className="h-4 w-2/3" />
                  <Skeleton className="h-3 w-full" />
                  <Skeleton className="h-3 w-4/5" />
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div className="relative rounded-2xl overflow-hidden text-center py-16 px-8">
            <img
              src="/brand/vestn-cta-contour.webp"
              alt=""
              aria-hidden="true"
              className="absolute inset-0 w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background/80 via-background/50 to-background/80" />
            <div className="relative z-10">
              <h2 className="font-display text-3xl font-bold text-foreground mb-4">
                Ready to Start?
              </h2>
              <Skeleton className="h-4 w-full max-w-xl mx-auto mb-8" />
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Skeleton className="h-12 w-48 rounded-xl" />
                <Skeleton className="h-12 w-40 rounded-xl" />
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
